import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './Header';
import Sidebar from './Sidebar';
import { useAuth } from '../../context/AuthContext';
import { useSidebar } from '../../contexts/SidebarContext';
import { ContextInitializer } from '../../hooks/useContextInitializer';
import GlobalLoadingIndicator from '../common/GlobalLoadingIndicator';
import SessionWarningDialog from '../common/SessionWarningDialog';
import { useGlobalLoading } from '../../hooks/useGlobalLoading';
import { useInactivityLogout } from '../../hooks/useInactivityLogout';

const SIDEBAR_WIDTH = 240;

const AuthenticatedLayout = () => {
  const { currentUser } = useAuth();
  const { sidebarOpen, toggleSidebar } = useSidebar();
  const { 
    isLoadingIndicatorOpen, 
    loadingStates, 
    closeLoadingIndicator 
  } = useGlobalLoading();

  // Déconnexion automatique après 30 minutes d'inactivité
  useInactivityLogout(30 * 60 * 1000, 5 * 60 * 1000);

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <ContextInitializer />
      <Header toggleSidebar={toggleSidebar} />
      <Sidebar open={sidebarOpen} width={SIDEBAR_WIDTH} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: 8,
          width: `calc(100% - ${sidebarOpen ? SIDEBAR_WIDTH : 0}px)`,
          px: 3,
          pt: 3,
          transition: 'all 0.2s',
          overflow: 'auto'
        }}
      >
        <Outlet />
      </Box>
      
      {/* Indicateur de chargement global */}
      <GlobalLoadingIndicator
        open={isLoadingIndicatorOpen}
        loadingStates={loadingStates}
        onClose={closeLoadingIndicator}
      />
      <SessionWarningDialog />
    </Box>
  );
};

export default AuthenticatedLayout; 